import { render, staticRenderFns } from "./CommodityMarketingAside.vue?vue&type=template&id=4bbef20e&"
import script from "./CommodityMarketingAside.vue?vue&type=script&lang=js&"
export * from "./CommodityMarketingAside.vue?vue&type=script&lang=js&"
import style0 from "./CommodityMarketingAside.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports